var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 16,
    viewBox: "0 0 512 512",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m255.998 0c-141.159 0-256.002 114.838-256.002 255.998 0 141.164 114.843 256.002 256.002 256.002 141.164 0 256.002-114.838 256.002-256.002 0-141.16-114.838-255.998-256.002-255.998z",
    fill: "#5555FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.148 142.339c17.633 17.642 27.355 41.18 27.355 66.28 0 25.09-9.722 48.634-27.355 66.271 0 0-106.597 106.593-106.687 106.692-20.335 20.326-54.459 20.298-74.761 0-20.34-20.34-20.307-54.45 0-74.761l100.022-100.022c4.679-4.689 12.279-4.689 16.968 0 4.693 4.684 4.693 12.283 0 16.972 0 0-99.88 99.88-100.022 100.022-11.095 11.099-11.062 29.751 0 40.817 11.066 11.071 29.779 11.043 40.822 0l106.69-106.692c13.099-13.109 20.322-30.619 20.322-49.298 0-18.689-7.222-36.199-20.322-49.308-13.109-13.099-30.619-20.321-49.308-20.321-18.694 0-36.199 7.222-49.303 20.321l-135.584 135.578c-4.689 4.689-12.288 4.689-16.972 0-4.684-4.679-4.684-12.279 0-16.972l135.584-135.579c17.642-17.637 41.176-27.35 66.276-27.35 25.094 0 48.637 9.713 66.275 27.35z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/AttachmentIcon.bde5e14305f4c9da73de728973209d43.svg";
export { ForwardRef as ReactComponent };